// Notion OAuth (public integration). Standard code flow: redirect to Notion's authorize
// screen (which includes its own page/DB picker), then Notion redirects back to /auth/notion
// with a `code` we exchange server-side. The client id comes from the backend (no VITE env).
export const NOTION_AUTH_STATE_STORAGE_KEY = 'notion_auth_state' as const
export type NotionAuthState = { rnd: string; referrerPath: string }

export const startNotionAuth = (opts: { clientId: string; referrerPath: string }) => {
  const state: NotionAuthState = {
    referrerPath: opts.referrerPath,
    rnd: Math.random().toString().slice(3, 12),
  }
  localStorage.setItem(NOTION_AUTH_STATE_STORAGE_KEY, JSON.stringify(state))

  const url = new URL('https://api.notion.com/v1/oauth/authorize')
  url.searchParams.set('client_id', opts.clientId)
  url.searchParams.set('response_type', 'code')
  url.searchParams.set('owner', 'user')
  url.searchParams.set('redirect_uri', `${window.location.origin}/auth/notion`)
  url.searchParams.set('state', JSON.stringify(state))
  window.location.href = url.toString()
}
